module.exports = __webpack_public_path__ + "static/tooltip-punctuation-dont-9834024d2e8e3555acc8f6ca6431b91f.png";